/**
	* Feature mode enum
	*
	* @remarks
	* Used mainly in views/DrawingTool
	*
	* @param Polygon	  -	  Polygon drawing mode
	* @param Point		  -	  Point drawing mode
	* @param LineString   -   Line string drawing mode
	* @param Circle       -   Circle drawing mode
	* @param Freehand     -   A freehand poly line
	* @param Text         -   A text caption
	* @param StreetView   -   A street view pin
*/
enum FeatureMode {
	Polygon,
	Point,
	LineString,
	LinearRing,
	Arrow,
	Circle,
	Freehand,
	Text,
	StreetView,
	SatelliteView
}

export default FeatureMode;